module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitCopy($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Copiar plano de aula da turma:")]), _vm._v(" "), _c('school-class-list', {
    attrs: {
      "only-select": true,
      "group": false,
      "by-theme": true,
      "scope": 'local',
      "context": 'LessonPlanningCopy'
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": !_vm.klass.schoolClassId
    }
  }, [_vm._v("\n\t\t\tCopiar plano de aula\n\t\t")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "btn red",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleCopy(false)
      }
    }
  }, [_vm._v("\n\t\t\tCancelar cópia\n\t\t")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3a1927c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/lessons/planning-copy/main.vue
// module id = 1102
// module chunks = 1